import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';

interface StatusPageProps {
  code: string;
  title: string;
  message: string;
}

function StatusPage({ code, title, message }: StatusPageProps) {
  return (
    <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', px: 2 }}>
      <Stack spacing={1.5} sx={{ alignItems: 'center', textAlign: 'center' }}>
        <Typography sx={{ fontSize: 56, fontWeight: 800, color: 'text.disabled', lineHeight: 1 }}>
          {code}
        </Typography>

        <Typography variant="h2">{title}</Typography>

        <Typography color="text.secondary" sx={{ maxWidth: 420 }}>
          {message}
        </Typography>

        <Button component={RouterLink} to="/dashboard" variant="contained" sx={{ mt: 1 }}>
          Back to dashboard
        </Button>
      </Stack>
    </Box>
  );
}

/** Shown when a route requires a permission the user does not hold. */
export function ForbiddenPage() {
  return (
    <StatusPage
      code="403"
      title="You do not have access to this"
      message="Your role does not include permission for this area. If you need it, ask an administrator to update your role in Settings."
    />
  );
}

/** Shown for an unknown route. */
export function NotFoundPage() {
  return (
    <StatusPage
      code="404"
      title="Page not found"
      message="That address does not exist. It may have been moved, or the link may be out of date."
    />
  );
}
